
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_499_4467)","fill":"#282828"}},[_c('path',{attrs:{"d":"M5.85 18.158a.82.82 0 00-1.16 0l-2.854 2.854a.82.82 0 101.16 1.16l2.853-2.854a.82.82 0 000-1.16zM10.49 22.799a.82.82 0 00-1.16 0l-3.887 3.888a.82.82 0 101.16 1.16l3.887-3.888a.82.82 0 000-1.16zM8.17 20.479a.82.82 0 00-1.16 0L1.835 25.65a.82.82 0 101.16 1.16l5.173-5.172a.82.82 0 000-1.16zM17.015.544L5.413 12.145c-.263.264-.45.579-.571.92h12.272a.82.82 0 00.82-.82V0c-.339.114-.659.283-.92.544zM27.455 7.505l-6.96-6.96A2.302 2.302 0 0019.58 0v8.419H28c-.121-.341-.282-.651-.545-.914z"}}),_c('path',{attrs:{"d":"M19.58 10.066v2.18a2.473 2.473 0 01-2.467 2.466h-2.18v8.447c.342-.12.657-.308.92-.572l11.601-11.6c.264-.264.424-.58.545-.92h-8.42zM4.842 14.71c.12.342.308.652.571.915l6.961 6.96c.263.264.573.451.914.572v-8.446H4.842z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_499_4467"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    